export default "__VITE_ASSET__e4a880f5__"